// Сбой капчи — громкий, а не тихий.
//
// ЧТО БЫЛО. Ошибка Turnstile (110200 «unknown domain», недоступный
// challenges.cloudflare.com, сбой отрисовки) доходила до формы только как
// пустой токен: виджет показывал «Unable to connect», кнопка не работала, и ни
// семья, ни мы не узнавали, что форма стоит. Здесь две половины ответа: событие
// в Sentry — чтобы узнали мы, и запасной текст с прямыми контактами — чтобы
// человек мог написать, не дожидаясь, пока капча оживёт.

export type TurnstileLang = "ru" | "az" | "en";

export const SUPPORT_WHATSAPP_URL = "https://wa.me/994513933197";
export const SUPPORT_EMAIL = "support@yolutap.com";

/**
 * Запасной текст. «WhatsApp» и адрес — ссылки, поэтому фраза разбита на
 * части: до ссылки, между ссылками, после.
 *
 * AZ — на вычитку носителем перед запуском (правило CLAUDE.md).
 */
export const TURNSTILE_FALLBACK: Record<
  TurnstileLang,
  { before: string; between: string; after: string }
> = {
  ru: {
    before: "Не удалось загрузить проверку. Напишите нам на ",
    between: " или на ",
    after: ".",
  },
  az: {
    before: "Yoxlamanı yükləmək mümkün olmadı. Bizə ",
    between: " və ya ",
    after: " ünvanına yazın.",
  },
  en: {
    before: "We couldn't load the security check. Message us on ",
    between: " or at ",
    after: ".",
  },
};

/** Язык виджета: явный — от формы, иначе атрибут <html lang>, иначе русский. */
export function turnstileLang(explicit?: string): TurnstileLang {
  const raw = (
    explicit ??
    (typeof document !== "undefined" ? document.documentElement.lang : "") ??
    ""
  )
    .slice(0, 2)
    .toLowerCase();
  return raw === "az" || raw === "en" ? raw : "ru";
}

/**
 * Событие в Sentry: тег turnstile_error = код ошибки, тег hostname = адрес,
 * на котором сломалось (110200 приходит ровно с адреса, которого нет в
 * списке виджета). Только в браузере и только из колбэков, поэтому SDK
 * подгружается лениво: в серверный рендер он не попадает. Если Sentry не
 * поднят (дев, превью без DSN), вызов ничего не делает. Мониторинг форму не
 * роняет никогда.
 */
export function reportTurnstileFailure(code: string): void {
  if (typeof window === "undefined") return;
  const hostname = window.location.hostname;
  console.warn("[turnstile] widget error", { code, hostname });
  import("@sentry/tanstackstart-react")
    .then((Sentry) => {
      Sentry.captureMessage(`[turnstile] widget error ${code}`, {
        level: "warning",
        tags: { turnstile_error: code, hostname },
      });
    })
    .catch(() => {
      /* мониторинг не роняет форму */
    });
}
